import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/gyranian-strengths-mapping.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1a3cfc7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container report-ready-page" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "gyranian-image",
    src: _imports_0,
    alt: "Gyranian rating his strengths"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Complete Review", -1))
const _hoisted_5 = { style: {"margin-bottom":"25px"} }

import axios from "axios";
import useAxios from "../composables/api";
import { InviteCodeSubjectApiModel, QuestionnaireApiModel } from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'invite-accept-page',
  props: {
    code: {}
  },
  setup(__props: any) {

const props = __props;

const { data } = useAxios<InviteCodeSubjectApiModel>(`/api/invitecode/subject/${props.code}`);

const redirectToReview = (model: QuestionnaireApiModel) => {
  if (model.customStrengthMappingId?.length > 0) {
    window.location.href = `/review/precheck/${model.id}`;
  } else {
    window.location.href = `/review/mappingstrengths/${model.id}`;
  }
};

const acceptInvite = async () => {
  const response = await axios.post<QuestionnaireApiModel>("/invite/accepted/", {
    code: props.code,
  });

  if (response.status === 200) {
    redirectToReview(response.data);
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(data))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(data).name) + " has invited you to complete a review of " + _toDisplayString(_unref(data).firstName) + "'s character strengths. This will help " + _toDisplayString(_unref(data).firstName) + " build an accurate self-view. ", 1),
            _createElementVNode("a", {
              onClick: acceptInvite,
              onKeydown: _withKeys(acceptInvite, ["enter"]),
              role: "button",
              tabindex: "0",
              class: "btn btn-primary btn-lg center-flex",
              "data-test": "get-started-button"
            }, " Get Started ", 32)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})